module.exports = __webpack_public_path__ + "static/startup2-611d1736936fa41540fe5a0cb9f54bbb.png";